import { useTranslation } from 'react-i18next'
import { isRouteErrorResponse, Link, useRouteError } from 'react-router'

/** Catches rendering/loader errors bubbling up from any route. */
export function RouteErrorFallback() {
  const { t } = useTranslation('common')
  const error = useRouteError()

  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : t('errors.UNKNOWN')

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-8 text-center">
      <h1 className="text-fg text-2xl font-bold">{t('errors.title')}</h1>
      <p className="text-fg-muted max-w-md">{message}</p>
      <Link
        to="/"
        className="bg-brand-600 hover:bg-brand-700 rounded-lg px-4 py-2 text-sm font-medium text-white transition"
      >
        {t('actions.backHome')}
      </Link>
    </div>
  )
}
